import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import profile_picture from "./about.jpg";
const GeneralIntro = () => {
    return <>
        <section id="about" className="about mt-5">
            <div className="container" data-aos="fade-up">

                <div className="section-title text-center mb-5">
                    <h2 className="fw-bold text-uppercase position-relative d-inline-block pb-2" >About Me</h2>
                    <p className="lead text-dark mx-auto mt-3" style={{ maxWidth: '800px' }}>
                        PhD Student in Computer Engineering specializing in physical-layer wireless security and deep learning, paired with professional experience building enterprise full-stack web applications.
                    </p>
                </div>


                <div className="row g-4 match-height">
                    <div className="col-lg-8">
                        <div className="card h-100 shadow-sm border-0 rounded-3 p-3">
                            <div className="card-body">
                                <h4 className="fw-bold text-dark mb-3">Professional Profile</h4>
                                <p className="text-secondary" style={{ lineHeight: '1.7' }}>
                                    I operate at the intersection of hardware-layer security engineering and modern software architecture. As a Graduate Research Assistant at the University of Arkansas, my academic scope addresses RF fingerprinting datasets, adversarial robustness algorithms, and mapping hardware impairments using deep neural networks. 
                                </p>
                                <p className="text-secondary mb-0" style={{ lineHeight: '1.7' }}>
                                    Prior to pursuing my doctoral track, I worked within industry teams engineering production-grade ERP engines, developing high-throughput modular codebases, and tuning enterprise database schemas. I enjoy transforming complex low-level engineering concepts into highly performant web applications.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="card h-100 shadow-sm border-0 rounded-3 p-3 text-white" style={{ backgroundColor: '#1a1d20' }}>
                            <div className="card-body d-flex flex-column justify-content-between">
                                <div>
                                    <h4 className="fw-bold mb-4" style={{ color: '#34b7a7' }}>Quick Stats</h4>
                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-3 d-flex align-items-center">
                                            <i className="bi bi-geo-alt me-3 fs-5" style={{ color: '#34b7a7' }}></i>
                                            <span>Fayetteville, AR, USA</span>
                                        </li>
                                        <li className="mb-3 d-flex align-items-center">
                                            <i className="bi bi-envelope me-3 fs-5" style={{ color: '#34b7a7' }}></i>
                                            <span className="text-wrap small">bimaladhikariofficials@gmail.com</span>
                                        </li>
                                        <li className="mb-3 d-flex align-items-center">
                                            <i className="bi bi-telephone me-3 fs-5" style={{ color: '#34b7a7' }}></i>
                                            <span>+1 (479) 332-9310</span>
                                        </li>
                                        <li className="d-flex align-items-center">
                                            <i className="bi bi-mortarboard me-3 fs-5" style={{ color: '#34b7a7' }}></i>
                                            <span>Ph.D. Student (CSCE)</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="border-top pt-3 mt-4 border-secondary text-center">
                                    {/* <a href="../resume" className="btn btn-sm px-4 py-2 fw-semibold text-dark text-uppercase rounded shadow-sm" style={{ backgroundColor: '#34b7a7'; border-color: '#34b7a7'; font-size: 0.75rem; letter-spacing: 1px; }}>View Full CV</a> */}
                                <Nav.Link as={Link} to="/portfolio" className='btn btn-sm px-4 py-2 fw-semibold text-dark text-uppercase rounded shadow-sm ms-2' style={{ backgroundColor: '#34b7a7', borderColor: '#34b7a7'}}>View Portfolio</Nav.Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </>;
};
export default GeneralIntro;